import { z } from 'zod';
import { objectId, timestampFields, FieldMetadata } from './base';

/**
 * EmailOptOut — per-organization suppression list for organizer-composed
 * broadcasts (ADR 0053). Written only by the public signed-token unsubscribe
 * endpoint; the broadcast recipient resolver excludes suppressed addresses.
 * Transactional emails (receipts, waivers) are NOT affected.
 */

export const EmailOptOutSchema = z.object({
  _id: objectId,
  organization: objectId,
  email: z.string().min(3).max(320), // stored lowercase
  ...timestampFields,
});

export type EmailOptOut = z.infer<typeof EmailOptOutSchema>;

export const emailOptOutMetadata: Record<string, FieldMetadata> = {
  _id: { hidden: true },
  organization: { ref: 'Organization', hidden: true },
  email: { label: 'Email' },
  created: { hidden: true },
  updated: { hidden: true },
};
